export function migrateHashUrl() {
  const { hash, search } = window.location;
  if (!hash || hash === "#") return;

  // HashRouter URLs: https://kunstsenter.no/#/program/42
  // Rewrite to /program/42 so BrowserRouter picks up the correct path.
  // Use replaceState so the /#/... entry is not left in browser history.
  if (hash.startsWith("#/")) {
    window.history.replaceState(null, "", hash.slice(1) + search);
  }
}
